<template>
  <session class="mobile-page-productservice">
    <Header />

    <Banner :title="bannerTitle" :content="bannerContent" :cover="IMG_BANNER_COVER" />
    
    <div class="productservice-block" style="margin-bottom: 64px;">
      <div class="block-header">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Title }}</span>
        <span />
      </div>
      <div class="block1-body">
        <div class="block-body-content">
          <div class="item" :class="{ active: item?.title == block1ListCurItem?.title }" v-for="(item, index) in block1List" :key="index" @click="item.action" @mouseenter="block1ListTab(index)">
            <Icon :name="item.icon" size="170" />
            <div class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.title }}</div>
            <div class="desc">{{ item?.desc }}</div>
            <div class="checkmore" ><Icon name="checkmore" size="24" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ LOCAL('checkmore') }}</span></div>
          </div>
        </div>
      </div>
    </div>

    <div class="productservice-block">
      <div class="block-header btb">
        <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block2Title }}</span>
        <span />
      </div>
      <div class="block2-body">
        <div class="block-body-content">
          <div class="item" :class="{ active: item?.title == block2ListCurItem?.title }" v-for="(item, index) in block2List" :key="index" @click="block2ListTab(index)">
            <div class="item-i">
              <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }" />
              <span class="name">{{ item?.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import Banner from '@/mobile/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';
  import Header from '@/mobile/components/header/index.vue';
  import Footer from '@/mobile/components/footer/index.vue';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';

  // imgs
  import IMG_BANNER_COVER from './images/cover.png';
  import IMG_PARTNER_AIA from './images/aia.png';
  import IMG_PARTNER_AXA from './images/axa.png';
  import IMG_PARTNER_HSBC from './images/hsbc.png';
  import IMG_PARTNER_NISSAY from './images/nissay.png';
  import IMG_PARTNER_SL from './images/sl.png';
  import router from '@/router';

  // banner
  const bannerTitle = ref('')
  const bannerContent = ref('')
  const bannerInit = () => {
    bannerTitle.value = LOCAL('productservice_productService');
    bannerContent.value = LOCAL('productservice_productService_desc');
  }
  onMounted(() => {
    bannerInit()
  })

  // 保障计划
  const block1Title = ref('');
  const block1List = ref([]);
  const block1ListCurItem = ref(null);
  const block1ListTab = (index = 0) => {
    block1ListCurItem.value = block1List.value[index];
  }
  const block1Init = () => {
    block1Title.value = LOCAL('productservice_coveragePlans');
    block1List.value = [
      { 
        icon: 'gerenbaozhang-blue', 
        title: LOCAL('productservice_coveragePlans_person'), 
        desc: LOCAL('productservice_coveragePlans_person_desc'),
        action: () => router.push('/plan/person')
      },
      { 
        icon: 'jigoubaozhang-blue',
        title: LOCAL('productservice_coveragePlans_unit'), 
        desc: LOCAL('productservice_coveragePlans_unit_desc'),
        action: () => router.push('/plan/unit')
      },
    ]
  }
  onMounted(() => {
    block1Init();
    block1ListTab();
  })

  // 合作伙伴
  const block2Title = ref('')
  const block2List = ref([]);
  const block2ListCurItem = ref(null);
  const block2ListTab = (index = 0) => {
    block2ListCurItem.value = block2List.value[index];
  }
  const block2Init = () => {
    block2Title.value = LOCAL('productservice_partners');
    block2List.value = [
      { name: LOCAL('productservice_partners_axa'), cover: IMG_PARTNER_AXA },
      { name: LOCAL('productservice_partners_nissay'), cover: IMG_PARTNER_NISSAY },
      { name: LOCAL('productservice_partners_hsbc'), cover: IMG_PARTNER_HSBC },
      { name: LOCAL('productservice_partners_sl'), cover: IMG_PARTNER_SL },
      { name: LOCAL('productservice_partners_aia'), cover: IMG_PARTNER_AIA },
    ]
  }
  onMounted(() => {
    block2Init();
    block2ListTab();
  })
</script>

<style scoped lang="less">
  @import "index.less";
</style>
